module.exports = {
  messages: {
    CN: {
      'sourcearea.sourceareaList': '原产地列表',
      'sourcearea.sourceareaInsert': '新建原产地',
      'sourcearea.sourceareaEdit': '编辑原产地',
      'sourcearea.insert': '新建',
      'sourcearea.sourceareaName': '原产地名称',
      'sourcearea.simpleWord': '简体',
      'sourcearea.goodsNum': '商品数量',
      'sourcearea.state': '状态',
      'sourcearea.enable': '启用',
      'sourcearea.stop': '停用',
      'sourcearea.updateTime': '更新时间',
      'sourcearea.operate': '操作',
      'sourcearea.edit': '编辑',
      'sourcearea.sureStop': '确定要停用吗？',
      'sourcearea.sureEnable': '确定要启用吗？',
      'sourcearea.sureDelete': '确定要删除吗？',
      'sourcearea.delete': '删除',
      'sourcearea.ok': '确定',
      'sourcearea.cancel': '取消',
      'sourcearea.updateOk': '更新成功',
      'sourcearea.deleteOk': '删除成功',
      'sourcearea.insertOk': '新增成功',
      'sourcearea.japanBrackets': '（日文）',
      'sourcearea.simpleWordBrackets': '（简体）',
      'sourcearea.traditionalBrackets': '（繁体）',
      'sourcearea.input': '请输入原产地名称',
      'sourcearea.maxLengthTest': '最多可输入50字符',
      'sourcearea.picture': '原产地图片',
      'sourcearea.tipsForUploadingPicture': '建议上传1:1比例、分辨率为{size}的图片。上传图片大小不能超过 {uploadLimit} MB',
      'productList.onTheShelf': '上架',
      'productList.offTheShelf': '下架'
    },
    JP: {
      'sourcearea.sourceareaList': '原産地リスト',
      'sourcearea.sourceareaInsert': '原産地を追加',
      'sourcearea.sourceareaEdit': '原産地を編集',
      'sourcearea.insert': '新規作成',
      'sourcearea.sourceareaName': '原産地名',
      'sourcearea.simpleWord': '簡体字',
      'sourcearea.goodsNum': '商品数量',
      'sourcearea.state': '状態',
      'sourcearea.enable': '有効',
      'sourcearea.stop': '無効',
      'sourcearea.updateTime': '更新時間',
      'sourcearea.operate': '操作',
      'sourcearea.edit': '編集',
      'sourcearea.sureStop': '停止しますか？',
      'sourcearea.sureEnable': '有効にしますか？',
      'sourcearea.sureDelete': '削除してもよろしいですか？',
      'sourcearea.delete': '削除',
      'sourcearea.ok': '確定',
      'sourcearea.cancel': 'キャンセル',
      'sourcearea.updateOk': '更新成功',
      'sourcearea.deleteOk': '削除しました',
      'sourcearea.insertOk': '追加しました',
      'sourcearea.japanBrackets': '（日文）',
      'sourcearea.simpleWordBrackets': '（简体）',
      'sourcearea.traditionalBrackets': '（繁体）',
      'sourcearea.input': '原産地名を入力してください',
      'sourcearea.maxLengthTest': '最多可输入50字符',
      'sourcearea.picture': '原産地画像',
      'sourcearea.tipsForUploadingPicture': '1:1の比率、解像度が{size}の画像をアップロードすることをお勧めします。アップロードする画像のサイズは{uploadLimit}MBを超えてはいけません',
      'productList.onTheShelf': '販売開始',
      'productList.offTheShelf': '販売停止'
    }
  }
};